"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _Back = _interopRequireDefault(require("../model/Back"));

var _Email = _interopRequireDefault(require("../model/Email"));

var _NextQuestion = _interopRequireDefault(require("../model/NextQuestion"));

var _Pets = _interopRequireDefault(require("../model/Pets"));

var _Question = _interopRequireDefault(require("../model/Question"));

var _SessionId = _interopRequireDefault(require("../model/SessionId"));

var _Summary = _interopRequireDefault(require("../model/Summary"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
* Api service.
* @module api/ApiApi
* @version 1.0.9
*/
var ApiApi = /*#__PURE__*/function () {
  /**
  * Constructs a new ApiApi. 
  * @alias module:api/ApiApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function ApiApi(apiClient) {
    _classCallCheck(this, ApiApi);

    this.apiClient = apiClient || _ApiClient.default.instance;
  }
  /**
   * Go back to the previous question
   * Go back to the previous question
   * @param {module:model/Back} data 
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Question} and HTTP response
   */


  _createClass(ApiApi, [{
    key: "apiV1ScBackCreateWithHttpInfo",
    value: function apiV1ScBackCreateWithHttpInfo(data) {
      var postBody = data; // verify the required parameter 'data' is set

      if (data === undefined || data === null) {
        throw new Error("Missing the required parameter 'data' when calling apiV1ScBackCreate");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['api_key'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _Question.default;
      return this.apiClient.callApi('/api/v1/sc/back/', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Go back to the previous question
     * Go back to the previous question
     * @param {module:model/Back} data 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Question}
     */

  }, {
    key: "apiV1ScBackCreate",
    value: function apiV1ScBackCreate(data) {
      return this.apiV1ScBackCreateWithHttpInfo(data).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Start a new symptom check
     * Start a new symptom check
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Question} and HTTP response
     */

  }, {
    key: "apiV1ScBeginCreateWithHttpInfo",
    value: function apiV1ScBeginCreateWithHttpInfo() {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['api_key'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _Question.default;
      return this.apiClient.callApi('/api/v1/sc/begin/', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Start a new symptom check
     * Start a new symptom check
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Question}
     */

  }, {
    key: "apiV1ScBeginCreate",
    value: function apiV1ScBeginCreate() {
      return this.apiV1ScBeginCreateWithHttpInfo().then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get Email address of user
     * End of Symptom Checker
     * @param {module:model/Email} data 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "apiV1ScEndCreateWithHttpInfo",
    value: function apiV1ScEndCreateWithHttpInfo(data) {
      var postBody = data; // verify the required parameter 'data' is set

      if (data === undefined || data === null) {
        throw new Error("Missing the required parameter 'data' when calling apiV1ScEndCreate");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['api_key'];
      var contentTypes = ['application/json'];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/v1/sc/end/', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get Email address of user
     * End of Symptom Checker
     * @param {module:model/Email} data 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "apiV1ScEndCreate",
    value: function apiV1ScEndCreate(data) {
      return this.apiV1ScEndCreateWithHttpInfo(data).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Post answer and get next question
     * Post answer and get next question
     * @param {module:model/NextQuestion} data 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Question} and HTTP response
     */

  }, {
    key: "apiV1ScNextCreateWithHttpInfo",
    value: function apiV1ScNextCreateWithHttpInfo(data) {
      var postBody = data; // verify the required parameter 'data' is set

      if (data === undefined || data === null) {
        throw new Error("Missing the required parameter 'data' when calling apiV1ScNextCreate");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['api_key'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _Question.default;
      return this.apiClient.callApi('/api/v1/sc/next/', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Post answer and get next question
     * Post answer and get next question
     * @param {module:model/NextQuestion} data 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Question}
     */

  }, {
    key: "apiV1ScNextCreate",
    value: function apiV1ScNextCreate(data) {
      return this.apiV1ScNextCreateWithHttpInfo(data).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Creates a pet for the logged in user
     * @param {module:model/Pets} data 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Pets} and HTTP response
     */

  }, {
    key: "apiV1ScPetCreateWithHttpInfo",
    value: function apiV1ScPetCreateWithHttpInfo(data) {
      var postBody = data; // verify the required parameter 'data' is set

      if (data === undefined || data === null) {
        throw new Error("Missing the required parameter 'data' when calling apiV1ScPetCreate");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['api_key'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _Pets.default;
      return this.apiClient.callApi('/api/v1/sc/pet/', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Creates a pet for the logged in user
     * @param {module:model/Pets} data 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Pets}
     */

  }, {
    key: "apiV1ScPetCreate",
    value: function apiV1ScPetCreate(data) {
      return this.apiV1ScPetCreateWithHttpInfo(data).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Delete an existing pet for the logged in user
     * @param {String} id 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "apiV1ScPetDeleteWithHttpInfo",
    value: function apiV1ScPetDeleteWithHttpInfo(id) {
      var postBody = null; // verify the required parameter 'id' is set

      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling apiV1ScPetDelete");
      }

      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['api_key'];
      var contentTypes = [];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/v1/sc/pet/{id}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Delete an existing pet for the logged in user
     * @param {String} id 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "apiV1ScPetDelete",
    value: function apiV1ScPetDelete(id) {
      return this.apiV1ScPetDeleteWithHttpInfo(id).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get a list of pets for the logged in user
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/Pets>} and HTTP response
     */

  }, {
    key: "apiV1ScPetListListWithHttpInfo",
    value: function apiV1ScPetListListWithHttpInfo() {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['api_key'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [_Pets.default];
      return this.apiClient.callApi('/api/v1/sc/pet/list/', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get a list of pets for the logged in user
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/Pets>}
     */

  }, {
    key: "apiV1ScPetListList",
    value: function apiV1ScPetListList() {
      return this.apiV1ScPetListListWithHttpInfo().then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Update an existing pet for the logged in user
     * @param {String} id 
     * @param {module:model/Pets} data 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Pets} and HTTP response
     */

  }, {
    key: "apiV1ScPetPartialUpdateWithHttpInfo",
    value: function apiV1ScPetPartialUpdateWithHttpInfo(id, data) {
      var postBody = data; // verify the required parameter 'id' is set

      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling apiV1ScPetPartialUpdate");
      } // verify the required parameter 'data' is set


      if (data === undefined || data === null) {
        throw new Error("Missing the required parameter 'data' when calling apiV1ScPetPartialUpdate");
      }

      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['api_key'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _Pets.default;
      return this.apiClient.callApi('/api/v1/sc/pet/{id}', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Update an existing pet for the logged in user
     * @param {String} id 
     * @param {module:model/Pets} data 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Pets}
     */

  }, {
    key: "apiV1ScPetPartialUpdate",
    value: function apiV1ScPetPartialUpdate(id, data) {
      return this.apiV1ScPetPartialUpdateWithHttpInfo(id, data).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Gets a pet for the logged in user
     * @param {String} id 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Pets} and HTTP response
     */

  }, {
    key: "apiV1ScPetReadWithHttpInfo",
    value: function apiV1ScPetReadWithHttpInfo(id) {
      var postBody = null; // verify the required parameter 'id' is set

      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling apiV1ScPetRead");
      }

      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['api_key'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _Pets.default;
      return this.apiClient.callApi('/api/v1/sc/pet/{id}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Gets a pet for the logged in user
     * @param {String} id 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Pets}
     */

  }, {
    key: "apiV1ScPetRead",
    value: function apiV1ScPetRead(id) {
      return this.apiV1ScPetReadWithHttpInfo(id).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get Summary of all the answers answered by the user
     * Get Summary of all the answers answered by the user
     * @param {module:model/SessionId} data 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Summary} and HTTP response
     */

  }, {
    key: "apiV1ScSummaryCreateWithHttpInfo",
    value: function apiV1ScSummaryCreateWithHttpInfo(data) {
      var postBody = data; // verify the required parameter 'data' is set

      if (data === undefined || data === null) {
        throw new Error("Missing the required parameter 'data' when calling apiV1ScSummaryCreate");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['api_key'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _Summary.default;
      return this.apiClient.callApi('/api/v1/sc/summary', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get Summary of all the answers answered by the user
     * Get Summary of all the answers answered by the user
     * @param {module:model/SessionId} data 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Summary}
     */

  }, {
    key: "apiV1ScSummaryCreate",
    value: function apiV1ScSummaryCreate(data) {
      return this.apiV1ScSummaryCreateWithHttpInfo(data).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);

  return ApiApi;
}();

exports.default = ApiApi;